@for (component of components | async; track component.componentId) {
  @if (component.lazyLoadingSettings?.activate) {
    @defer (when shouldComponentRender(lazyLoadingState(), component); prefetch on idle) {
      <ng-container *ngComponentOutlet="component.component; injector: component.injector; inputs: component.inputs" />
    }
  } @else {
    <!--For now, injector and inputs elements going to coexist but the idea is remove the injector from all dynamic components and leave only the inputs element -->
    <ng-container *ngComponentOutlet="component.component; injector: component.injector; inputs: component.inputs" />
  }
}
